__turbopack_context__.v({
  "bigValue": "PerformanceMatrix-module__epwCVW__bigValue",
  "bounce-in": "PerformanceMatrix-module__epwCVW__bounce-in",
  "card": "PerformanceMatrix-module__epwCVW__card",
  "cardBody": "PerformanceMatrix-module__epwCVW__cardBody",
  "cardHoverActive": "PerformanceMatrix-module__epwCVW__cardHoverActive",
  "cardViz": "PerformanceMatrix-module__epwCVW__cardViz",
  "cardVizWrap": "PerformanceMatrix-module__epwCVW__cardVizWrap",
  "cards": "PerformanceMatrix-module__epwCVW__cards",
  "categoryHeader": "PerformanceMatrix-module__epwCVW__categoryHeader",
  "categoryPanel": "PerformanceMatrix-module__epwCVW__categoryPanel",
  "categorySubtitle": "PerformanceMatrix-module__epwCVW__categorySubtitle",
  "categoryTitle": "PerformanceMatrix-module__epwCVW__categoryTitle",
  "chip-count": "PerformanceMatrix-module__epwCVW__chip-count",
  "chip-currency": "PerformanceMatrix-module__epwCVW__chip-currency",
  "chip-multiplier": "PerformanceMatrix-module__epwCVW__chip-multiplier",
  "chip-percent": "PerformanceMatrix-module__epwCVW__chip-percent",
  "chip-percent-neg": "PerformanceMatrix-module__epwCVW__chip-percent-neg",
  "chip-score": "PerformanceMatrix-module__epwCVW__chip-score",
  "chip-time": "PerformanceMatrix-module__epwCVW__chip-time",
  "clock": "PerformanceMatrix-module__epwCVW__clock",
  "clock-tick": "PerformanceMatrix-module__epwCVW__clock-tick",
  "clockTick": "PerformanceMatrix-module__epwCVW__clockTick",
  "column": "PerformanceMatrix-module__epwCVW__column",
  "dimmed": "PerformanceMatrix-module__epwCVW__dimmed",
  "eyebrow": "PerformanceMatrix-module__epwCVW__eyebrow",
  "footnote": "PerformanceMatrix-module__epwCVW__footnote",
  "grid": "PerformanceMatrix-module__epwCVW__grid",
  "metricAccent": "PerformanceMatrix-module__epwCVW__metricAccent",
  "metricDesc": "PerformanceMatrix-module__epwCVW__metricDesc",
  "metricHoverPulse": "PerformanceMatrix-module__epwCVW__metricHoverPulse",
  "metricTitle": "PerformanceMatrix-module__epwCVW__metricTitle",
  "metricValue": "PerformanceMatrix-module__epwCVW__metricValue",
  "multiplier": "PerformanceMatrix-module__epwCVW__multiplier",
  "multiplierBounce": "PerformanceMatrix-module__epwCVW__multiplierBounce",
  "pulse": "PerformanceMatrix-module__epwCVW__pulse",
  "radial": "PerformanceMatrix-module__epwCVW__radial",
  "radial-pulse": "PerformanceMatrix-module__epwCVW__radial-pulse",
  "radialPulse": "PerformanceMatrix-module__epwCVW__radialPulse",
  "ringValue": "PerformanceMatrix-module__epwCVW__ringValue",
  "ringWrap": "PerformanceMatrix-module__epwCVW__ringWrap",
  "section": "PerformanceMatrix-module__epwCVW__section",
  "sectionSub": "PerformanceMatrix-module__epwCVW__sectionSub",
  "sectionTitle": "PerformanceMatrix-module__epwCVW__sectionTitle",
  "typeChip": "PerformanceMatrix-module__epwCVW__typeChip",
});
